import corporateLogo from "../assets/corporate_logo.png";
import retailLogo from "../assets/retail_logo.png";
import Image from "react-bootstrap/Image";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import { MODE_RETAIL } from "../lib/siteMode";
import { useSiteMode } from "./SiteModeProvider";
import OurPartners from "./OurPartners";

export default function Footer() {
  const isRetail = useSiteMode() === MODE_RETAIL;
  const logo = isRetail ? retailLogo : corporateLogo;

  return (
    <footer className="foot mt-5">
      <OurPartners />
      <Row className="align-items-center g-4">
        <Col md={4} className="text-center text-md-start">
          <div className="d-flex align-items-center justify-content-center justify-content-md-start gap-3">
            <Image
              src={logo}
              alt="Financials.hu"
              height="45"
              width="45"
              className="footer-logo"
            />
            <span
              className="fw-bold fs-5"
              style={{ color: "var(--title-color)", letterSpacing: "1px" }}
            >
              FINANCIALS.hu
            </span>
          </div>
          <p className="small mt-2 mb-0 opacity-75">
            {isRetail
              ? "Lakossági pénzügyek független szakértője."
              : "Vállalati pénzügyek független szakértője."}
          </p>
        </Col>

        <Col md={4} className="text-center">
          <div className="d-flex justify-content-center gap-3">
            <Link to="/impresszum">Impresszum</Link>
            <Link to="/rolunk">Rólunk</Link>
            <Link to="/adatkezelesi-tajekoztato">Adatkezelés</Link>
          </div>
        </Col>

        <Col md={4} className="text-center text-md-end">
          <p className="mb-0 small opacity-75">
            © {new Date().getFullYear()} – Minden jog fenntartva.
          </p>
        </Col>
      </Row>
    </footer>
  );
}
